<template>
    <el-popover ref="popoverRef" placement="bottom" trigger="hover" :width="210">
        <template #reference>
            <slot></slot>
        </template>
        <div class="risk_change">
            <p>风险等级修改</p>
            <ul>
                <li class="high" @click="onChange('high')">高风险</li>
                <li class="middle" @click="onChange('middle')">中风险</li>
                <li class="low" @click="onChange('low')">低风险</li>
            </ul>
        </div>
    </el-popover>
</template>

<script setup>
import { ref } from "vue";
import { apiWeeklyRisk } from "@/request/api";

const props = defineProps({
    artcle: { type: Object, default: {} },
});
const emit = defineEmits(["change"]);
const popoverRef = ref(null);

const onChange = async (e) => {
    popoverRef.value && popoverRef.value.hide();
    // 发送请求
    const { code } = await apiWeeklyRisk({ articleId: props.artcle.articleId, risk: e });
    if (code !== "0") return;
    emit("change", e);
};
</script>

<style scoped lang="scss">
.risk_change {
    p {
        font-size: 12px;
    }
    ul {
        display: flex;
        margin-top: 4px;
        li {
            display: inline-block;
            height: 16px;
            line-height: 16px;
            display: flex;
            align-items: center;
            border-radius: 8px;
            color: #fff;
            font-size: 12px;
            padding: 0 8px;
            margin-top: 4px;
            margin-left: 8px;
            cursor: pointer;
            user-select: none;
            &.high {
                background-color: #ff2f00;
            }
            &.middle {
                background-color: #ff8000;
            }
            &.low {
                background-color: #43cf7c;
            }
        }
    }
}
</style>
